"use client"

import * as React from "react"

import { cn } from "@/lib/utils"

export interface FilterButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label?: string
  icon?: React.ReactNode
  isActive?: boolean
  iconClassName?: string
}

export function FilterButton({
  label,
  icon,
  isActive = false,
  className,
  iconClassName,
  children,
  ...props
}: FilterButtonProps) {
  return (
    <button
      className={cn(
        "bg-gray-100 rounded-full px-4 py-2 text-sm font-medium",
        "flex items-center justify-center gap-2 whitespace-nowrap",
        "hover:bg-gray-300/50 transition-colors",
        "focus:outline-none focus:ring-2 focus:ring-gray-400/50",
        isActive && "bg-primary text-primary-foreground hover:bg-primary/90",
        className
      )}
      {...props}
    >
      {icon && (
        <span className={cn("flex items-center justify-center", iconClassName)}>
          {icon}
        </span>
      )}
      {label && <span>{label}</span>}
      {children}
    </button>
  )
}
